/** Roster instance statuses the backend sends; each has a display label under `shifts:instanceStatus`. */
export const INSTANCE_STATUSES = ['SCHEDULED', 'WORKED', 'ABSENT', 'ON_LEAVE', 'HOLIDAY', 'CANCELLED'] as const;
export type InstanceStatus = typeof INSTANCE_STATUSES[number];

export const isInstanceStatus = (value: string | null | undefined): value is InstanceStatus =>
    !!value && (INSTANCE_STATUSES as readonly string[]).includes(value);
